import produce from "immer";
import { LoadState } from "../../../constants/enums";
import {
  IGLMonthlySummaryState,
  initialGLMonthlySummaryState,
} from "./GLMonthlySummary.types";
import { GLMonthlySummaryActions } from ".";
import {
  CLEAR_GL_MONTHLY_SUMMARY_STATE,
  FETCH_GL_MONTHLY_SUMMARY_LIST_FAILED,
  FETCH_GL_MONTHLY_SUMMARY_LIST_PROGRESS,
  FETCH_GL_MONTHLY_SUMMARY_LIST_SUCCESS,
} from "./GLMonthlySummaryActions";

export const glMonthlySummaryReducer = (
  state: IGLMonthlySummaryState = initialGLMonthlySummaryState,
  action: GLMonthlySummaryActions
) => {
  switch (action.type) {
    case FETCH_GL_MONTHLY_SUMMARY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.loading = LoadState.InProgress;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_GL_MONTHLY_SUMMARY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
        draftState.error = null;
      });
      return newState;
    }

    case FETCH_GL_MONTHLY_SUMMARY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.list = [];
        draftState.totalRecords = 0;
        draftState.loading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_GL_MONTHLY_SUMMARY_STATE: {
      return initialGLMonthlySummaryState;
    }

    default:
      return state;
  }
};
